import {Model} from 'vue-mc'
import api from '../lib/api'

/**
 * Base model
 */
class BaseModel extends Model {
  getRequest (config) {
    config.baseURL = 'http://localhost:8000/api'

    let auth = this.getAuth()
    if (auth !== null) {
      config.headers.Authorization = auth.token_type + ' ' + auth.access_token
    }

    return super.getRequest(config)
  }

  request (config, onRequest, onSuccess, onFailure) {
    config = config()
    return new Promise(function (resolve, reject) {
      let check = onRequest()

      // Request should be skipped but the promise should not be resolved.
      if (check === false) {
        return
      }

      // Request should be skipped but should be considered successful.
      if (check === true) {
        onSuccess(null)
        return resolve(null)
      }

      return api(config)
        .then(function (response) {
          onSuccess(response)
          return resolve(response)
        })

        .catch(function (error) {
          onFailure(error)
          return reject(error)
        })

        .catch(function (error) {
          return reject(error)
        })
    })
  }

  onFetchSuccess (response) {
    if (response && response.data) {
      this.assign(response.data)
    }

    this.emit('fetch', { error: null })
  }

  onSaveSuccess (response) {
    // Clear errors because the request was successful.
    this.clearErrors()

    // Update this model with the data that was returned in the response.
    if (response) {
      this.update(response.data)
    }

    this.saving = false
    this.fatal = false

    // Automatically add to all registered collections.
    this.addToAllCollections()

    this.emit('save', { error: null })
  }

  getAuth () {
    let json = localStorage.getItem('auth')
    if (json === null) {
      return null
    }

    return JSON.parse(json)
  }
}

export {BaseModel}



//////////////////
// WEBPACK FOOTER
// ./src/models/BaseModel.js
// module id = 845
// module chunks = 1